import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '~/components/Typography'

type Investor = {
  fullName: string
  i18nJobKey: string
}

const BASE_I18N_KEY = 'team:investors.members'

export const INVESTORS: Investor[] = [
  {
    fullName: 'Hassanein Hiridjee',
    i18nJobKey: `${BASE_I18N_KEY}.hassanein.job`
  },
  {
    fullName: 'Christian Dargnat',
    i18nJobKey: `${BASE_I18N_KEY}.christian.job`
  },
  {
    fullName: 'Emmanuel Goldstein',
    i18nJobKey: `${BASE_I18N_KEY}.emmanuel.job`
  },
  {
    fullName: 'Patrick Levy-Waitz',
    i18nJobKey: `${BASE_I18N_KEY}.patrick.job`
  },
  {
    fullName: 'Jean-Marie Messier',
    i18nJobKey: `${BASE_I18N_KEY}.jeanMarie.job`
  },
  {
    fullName: 'Jean Moueix',
    i18nJobKey: `${BASE_I18N_KEY}.jean.job`
  },
  {
    fullName: 'Xavier Niel',
    i18nJobKey: `${BASE_I18N_KEY}.xavier.job`
  },
  {
    fullName: 'Rodolphe Saadé',
    i18nJobKey: `${BASE_I18N_KEY}.rodolphe.job`
  }
]

const InvestorsList = () => {
  const { t } = useTranslation()

  return (
    <div className="flex gap-12">
      {INVESTORS.map((investor) => {
        return (
          <div className="mr-8 flex flex-col gap-2" key={investor.fullName}>
            <Typography align="center" variant="h5">
              {investor.fullName}
            </Typography>
            <Typography
              align="center"
              variant="body2"
              className="text-white/50"
            >
              {t(investor.i18nJobKey)}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}

export default InvestorsList
